import Component from 'inferno-component';

class HomePageDropdownSearch extends Component {
  render() {
    const { searchResult, selectedClass } = this.props;
    const wordLink = `/definition/${searchResult.id}`;
    return (
      <div className={`home-page-dropdown-search--item ${selectedClass}`}>
        <a href={wordLink}>
          <div className="definition">
            <span className="definition__word">{searchResult.word}</span>
            {searchResult.definitions.length > 1 && (
              <span className="definition__additional-link">
                {searchResult.definitions.length - 1} additional definition(s)
                &#187;
              </span>
            )}
            <div>
              {searchResult.definitions[0].ps && (
                <span className="definition__word-class">
                  {searchResult.definitions[0].ps}{' '}
                </span>
              )}
              <span className="definition__text">
                {searchResult.definitions[0].dtxt}
              </span>
            </div>
          </div>
        </a>
      </div>
    );
  }
}

export default HomePageDropdownSearch;



// WEBPACK FOOTER //
// ./src/components/HomePageDropdownSearch.js